import {
  bstatisticUrl,
  fitConsUrl,
  mpcUrl,
  PhastCons100wayUrl,
  PhastCons17wayUrl,
  PhastCons20wayUrl,
  PhastCons30wayUrl,
  PhyloP100wayUrl,
  PhyloP17wayUrl,
  PhyloP20wayUrl,
  PhyloP30wayUrl,
  SiPhy29wayUrl,
} from "./ConservationScoresUrls";

export const DBNSFP_DATABASES = [
  {
    name: "PhyloP17way",
    helpTextName: "PhyloP17way",
    url: PhyloP17wayUrl,
    a: "phylop17way_primate",
    b: "phylop17way_primate_rankscore",
  },
  {
    name: "PhyloP20way",
    helpTextName: "PhyloP20way",
    url: PhyloP20wayUrl,
    a: "phylop20way_mammalian",
    b: "phylop20way_mammalian_rankscore",
  },
  {
    name: "PhyloP30way",
    helpTextName: "PhyloP30way",
    url: PhyloP30wayUrl,
    a: "phylop30way_mammalian",
    b: "phylop30way_mammalian_rankscore",
  },
  {
    name: "PhyloP100way",
    helpTextName: "PhyloP100way",
    url: PhyloP100wayUrl,
    a: "phylop100way_vertebrate",
    b: "phylop100way_vertebrate_rankscore",
  },
  {
    name: "PhastCons17way",
    helpTextName: "PhastCons17way",
    url: PhastCons17wayUrl,
    a: "phastcons17way_primate",
    b: "phastcons17way_primate_rankscore",
  },
  {
    name: "PhastCons20way",
    helpTextName: "PhastCons20way",
    url: PhastCons20wayUrl,
    a: "phastcons20way_mammalian",
    b: "phastcons20way_mammalian_rankscore",
  },
  {
    name: "PhastCons30way",
    helpTextName: "PhastCons30way",
    url: PhastCons30wayUrl,
    a: "phastcons30way_mammalian",
    b: "phastcons30way_mammalian_rankscore",
  },
  {
    name: "PhastCons100way",
    helpTextName: "PhastCons100way",
    url: PhastCons100wayUrl,
    a: "phastcons100way_vertebrate",
    b: "phastcons100way_vertebrate_rankscore",
  },
  {
    name: "fitCons-gm",
    helpTextName: "fitCons-gm",
    url: fitConsUrl,
    a: "gm12878_fitcons_score",
    b: "gm12878_fitcons_rankscore",
    c: "gm12878_confidence_value",
  },
  {
    name: "fitCons H1 (H1-hESC)",
    helpTextName: "fitCons-h1-hesc",
    url: fitConsUrl,
    a: "h1_hesc_fitcons_score",
    b: "h1_hesc_fitcons_rankscore",
    c: "h1_hesc_confidence_value",
  },
  {
    name: "fitCons HU (HUVEC)",
    helpTextName: "fitCons-huvec",
    url: fitConsUrl,
    a: "huvec_fitcons_score",
    b: "huvec_fitcons_rankscore",
    c: "huvec_confidence_value",
  },
  {
    name: "Integrated fitCons",
    helpTextName: "integrated-fitCons",
    url: fitConsUrl,
    a: "integrated_fitcons_score",
    b: "integrated_fitcons_rankscore",
    c: "integrated_confidence_value",
  },
  {
    name: "SiPhy29way",
    helpTextName: "SiPhy29way",
    url: SiPhy29wayUrl,
    a: "siphy_29way_logodds",
    b: "siphy_29way_logodds_rankscore",
    c: "siphy_29way_pi",
  },
  {
    name: "MPC",
    helpTextName: "MPC",
    url: mpcUrl,
    a: "mpc_score",
    b: "mpc_rankscore",
  },
  {
    name: "bstatistic",
    helpTextName: "bstatistic",
    url: bstatisticUrl,
    a: "bstatistic",
    b: "bstatistic_rankscore",
  },
];

export const DBNSFP_CONSERVATION_FIELDS = [
  "phylop17way_primate",
  "phylop17way_primate_rankscore",
  "phylop20way_mammalian",
  "phylop20way_mammalian_rankscore",
  "phylop30way_mammalian",
  "phylop30way_mammalian_rankscore",
  "phylop100way_vertebrate",
  "phylop100way_vertebrate_rankscore",
  "phastcons17way_primate",
  "phastcons17way_primate_rankscore",
  "phastcons20way_mammalian",
  "phastcons20way_mammalian_rankscore",
  "phastcons30way_mammalian",
  "phastcons30way_mammalian_rankscore",
  "phastcons100way_vertebrate",
  "phastcons100way_vertebrate_rankscore",
  "gm12878_fitcons_score",
  "gm12878_fitcons_rankscore",
  "gm12878_confidence_value",
  "h1_hesc_fitcons_score",
  "h1_hesc_fitcons_rankscore",
  "h1_hesc_confidence_value",
  "huvec_fitcons_score",
  "huvec_fitcons_rankscore",
  "huvec_confidence_value",
  "integrated_fitcons_score",
  "integrated_fitcons_rankscore",
  "integrated_confidence_value",
  "siphy_29way_logodds_rankscore",
  "siphy_29way_logodds",
  "siphy_29way_pi",
  "mpc_score",
  "mpc_rankscore",
  "bstatistic",
  "bstatistic_rankscore",
];
